<template>
  <div class="img-wrapper">
    <b-img class="thumbnail" :src="getImageSrc(item.inventory.images)" v-if="item.inventory.images.length"
                @click="showImageGallery(item.inventory)" />

    <b-img v-else class="no-img" src="@/assets/no-image-available.png" top/>
  </div>
</template>

<script>
export default {
  name: "BatchLotUpImage",
  props: {
    item: {
      required: true
    }
  },
  methods: {
    getImageSrc(images) {
      for (let img of images) {
        if (img.data && (img.data.sm || img.data.original)) {
          return img.data.sm ? img.data.sm.url : img.data.original.url;
        }
      }
      return null;
    },
    showImageGallery(item) {
      this.$emit("onGalleryClick", {
        items: item.images,
        title: item.short_description
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.img-wrapper {
  height: 140px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.thumbnail,
.no-img{
  z-index: 0;
  max-width: 100%;
  max-height: 100%;
  cursor: pointer;
}
</style>
